/**
 * Kushki Info Enums
 */

export enum PlatformCode {
  CAJITA = "KP007",
}

export enum KushkiInfoProps {
  PLATFORM_ID = "platformId",
  PLATFORM_VERSION = "platformVersion",
}



// WEBPACK FOOTER //
// ./src/shared/KushkiInfoEnum.ts